'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (url, unicodeDomains, requireProtocol) {
  if (unicodeDomains == null) {
    unicodeDomains = true;
  }

  if (requireProtocol == null) {
    requireProtocol = true;
  }

  if (!url) {
    return false;
  }

  var urlParts = url.match(_validateUrlUnencoded2.default);

  if (!urlParts || urlParts[0] !== url) {
    return false;
  }

  var scheme = urlParts[1],
      authority = urlParts[2],
      path = urlParts[3],
      query = urlParts[4],
      fragment = urlParts[5];

  if (!((!requireProtocol || isValidMatch(scheme, _validateUrlScheme2.default) && scheme.match(/^https?$/i)) && isValidMatch(path, _validateUrlPath2.default) && isValidMatch(query, _validateUrlQuery2.default, true) && isValidMatch(fragment, _validateUrlFragment2.default, true))) {
    return false;
  }

  return unicodeDomains && isValidMatch(authority, _validateUrlUnicodeAuthority2.default) || !unicodeDomains && isValidMatch(authority, _validateUrlAuthority2.default);
};

var _validateUrlAuthority = require('./regexp/validateUrlAuthority');

var _validateUrlAuthority2 = _interopRequireDefault(_validateUrlAuthority);

var _validateUrlFragment = require('./regexp/validateUrlFragment');

var _validateUrlFragment2 = _interopRequireDefault(_validateUrlFragment);

var _validateUrlPath = require('./regexp/validateUrlPath');

var _validateUrlPath2 = _interopRequireDefault(_validateUrlPath);

var _validateUrlQuery = require('./regexp/validateUrlQuery');

var _validateUrlQuery2 = _interopRequireDefault(_validateUrlQuery);

var _validateUrlScheme = require('./regexp/validateUrlScheme');

var _validateUrlScheme2 = _interopRequireDefault(_validateUrlScheme);

var _validateUrlUnencoded = require('./regexp/validateUrlUnencoded');

var _validateUrlUnencoded2 = _interopRequireDefault(_validateUrlUnencoded);

var _validateUrlUnicodeAuthority = require('./regexp/validateUrlUnicodeAuthority');

var _validateUrlUnicodeAuthority2 = _interopRequireDefault(_validateUrlUnicodeAuthority);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidMatch(string, regex, optional) {
  if (!optional) {
    // RegExp["$&"] is the text of the last match
    // blank strings are ok, but are falsy, so we check stringiness instead of truthiness
    return typeof string === 'string' && string.match(regex) && RegExp['$&'] === string;
  }

  // RegExp["$&"] is the text of the last match
  return !string || string.match(regex) && RegExp['$&'] === string;
} // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];